
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "layout": "post",
  "title": "First Snowfall of the Winter",
  "date": "2015-01-06",
  "comments": "true",
  "categories": "[\"snow\", \"photo\", \"philadelphia\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "created": "2015-01-06",
  "tags": [
    "snow",
    "photo",
    "philadelphia"
  ],
  "draft": false
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":["Washington Square Park on my way home from the train."]},"\n",{"type":"img","props":{"src":"/static/images/posts/20150106-20150106-DSCF9517.jpg","alt":"snow1"}},"\n",{"type":"img","props":{"src":"/static/images/posts/20150106-20150106-DSCF9518.jpg","alt":"snow1"}}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
